import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <div {...{
        "className": "gatsby-resp-iframe-wrapper",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "height": "0",
          "overflow": "hidden"
        }
      }}>{` `}<iframe parentName="div" {...{
          "src": "https://www.youtube.com/embed/ss9joPm2M1U",
          "frameBorder": "0",
          "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          "allowFullScreen": true,
          "style": {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%"
          }
        }}></iframe>{` `}</div>
      <ul>
        <li parentName="ul">{`Application Modernization DevOps, Monolith to Container.`}</li>
        <li parentName="ul">{`The following steps will deploy the modernized Customer Order Services application in a WebSphere Liberty container to a Red Hat OpenShift cluster.`}</li>
        <li parentName="ul">{`The DevOps process is composed of Continous Integration (CI) with OpenShift Pipelines (Tekton) and Continous Deployment (CD) with GitOps engine ArgoCD`}</li>
      </ul>
    </PageDescription>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Prerequisites`}</p>
        <ul parentName="li">
          <li parentName="ul">{`The instructor should `}<a parentName="li" {...{
              "href": "/dev-guide/workshop/setup"
            }}>{`Setup Workshop Environment`}</a></li>
          <li parentName="ul">{`The student should `}<a parentName="li" {...{
              "href": "/dev-guide/workshop/terminal"
            }}>{`Setup CLI and Terminal Shell`}</a></li>
          <li parentName="ul">{`An user with cluster-admin (ie kubeadmin) needs to deploy a DB2 instance to be shared by all the users`}</li>
        </ul>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc new-project db2
oc create -n db2 serviceaccount mysvcacct
oc adm policy add-scc-to-user privileged system:serviceaccount:db2:mysvcacct
oc apply -n db2 -f "http://$(oc get route -n tools gogs --template='{{.spec.host}}')/toolkit/appmod-liberty-toolkit/raw/master/db2/db2-dc.yaml"
oc apply -n db2 -f "http://$(oc get route -n tools gogs --template='{{.spec.host}}')/toolkit/appmod-liberty-toolkit/raw/master/db2/db2-service.yaml"
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`(Optional) Analyze the application using the following guide `}<a parentName="p" {...{
            "href": "https://ibm-cloud-architecture.github.io/modernization-playbook/applications/liberty/liberty-analyze"
          }}>{`Modernizing runtimes with Liberty`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`Download `}<a parentName="li" {...{
              "href": "https://www.ibm.com/garage/method/practices/learn/ibm-transformation-advisor/"
            }}>{`Transformation Advisor`}</a></li>
          <li parentName="ul">{`The results of a Data Collector is already provided provided download `}<a href="/AppSrv01.zip" target="_blank">{`AppSrv01.zip`}</a></li>
          <li parentName="ul">{`Upload the data collection into Transformation Advisor`}</li>
          <li parentName="ul">{`Review the CustomerOrderServicesApp.ear analysis`}</li>
          <li parentName="ul">{`The migration path files have been deployed to git for this lab.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Instructor will provide the following info:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`OpenShift Console URL (OCP_CONSOLE_URL)`}</li>
          <li parentName="ul">{`The username and password for OpenShift and Git Server (default values are user01, user02, etc.. for users and `}<inlineCode parentName="li">{`password`}</inlineCode>{` for password).`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set `}<inlineCode parentName="p">{`TOOLKIT_USERNAME`}</inlineCode>{` environment variable.
If you are participation in a workshop replace `}<inlineCode parentName="p">{`userdemo`}</inlineCode>{` with your assigned username (ex. `}<inlineCode parentName="p">{`user01`}</inlineCode>{`).`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`TOOLKIT_USERNAME=userdemo
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login to OpenShift using `}<inlineCode parentName="p">{`oc`}</inlineCode></p>
        <ul parentName="li">
          <li parentName="ul">{`If using IBM Cloud cluster then login with your IBM account email and IAM API Key or Token by using the `}<strong parentName="li">{`Copy Login Command`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "439px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "46.18055555555556%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFu2jAiPB//xAAZEAACAwEAAAAAAAAAAAAAAAAAAwEEFCD/2gAIAQEAAQUCwKIpqgyK4//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAIBBQAAAAAAAAAAAAAAAAABEQIgMTKR/9oACAEBAAY/As1EQ2avtn//xAAaEAEAAQUAAAAAAAAAAAAAAAABEABBgdHx/9oACAEBAAE/IemaoPJLLLx//9oADAMBAAIAAwAAABBwL//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EEf/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPxBX/8QAGxAAAgMAAwAAAAAAAAAAAAAAESEAARAxgaH/2gAIAQEAAT8QYZBz13yPBDsPbLx//9k=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Login",
                "title": "Login",
                "src": "/dev-guide/static/75b1c2097aefc07605cbecf798f7c126/88c5d/login.jpg",
                "srcSet": ["/dev-guide/static/75b1c2097aefc07605cbecf798f7c126/69549/login.jpg 288w", "/dev-guide/static/75b1c2097aefc07605cbecf798f7c126/88c5d/login.jpg 439w"],
                "sizes": "(max-width: 439px) 100vw, 439px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`If using a cluster that was configured with the workshop scripts outside IBM Cloud then use respective assigned username (ex. `}<inlineCode parentName="li">{`user01`}</inlineCode>{`), and the password is `}<inlineCode parentName="li">{`password`}</inlineCode></li>
        </ul>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc login $OCP_URL -u $TOOLKIT_USERNAME -p password
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set `}<inlineCode parentName="p">{`TOOLKIT_PROJECT`}</inlineCode>{` environment variable
If you are participation in a workshop replace `}<inlineCode parentName="p">{`projectdemo`}</inlineCode>{` based on your assigned username (ex. `}<inlineCode parentName="p">{`project01`}</inlineCode>{`).`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`TOOLKIT_PROJECT=projectdemo
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a project/namespace using your project prefix, and `}<inlineCode parentName="p">{`-dev`}</inlineCode>{` and suffix`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc sync $TOOLKIT_PROJECT-dev
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Fork Inventory Sample Application Java`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Open Developer Dashboard from the OpenShift Console`}</li>
          <li parentName="ul">{`Select Starter Kits`}</li>
          <li parentName="ul">{`Select `}<strong parentName="li">{`Liberty AppMod`}</strong>{` (Java)`}</li>
          <li parentName="ul">{`Click Fork`}</li>
          <li parentName="ul">{`Login into GIT Sever using the provided username and password (ie `}<inlineCode parentName="li">{`userdemo`}</inlineCode>{` and `}<inlineCode parentName="li">{`password`}</inlineCode>{`)`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`Fork Repository`}</strong></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Setup environment variable `}<inlineCode parentName="p">{`GIT_URL`}</inlineCode>{` for the git url using the value from previous step or as following`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`GIT_REPO=appmod-liberty-toolkit
GIT_URL=http://\${TOOLKIT_USERNAME}:password@$(oc get route -n tools gogs --template='{{.spec.host}}')/\${TOOLKIT_USERNAME}/\${GIT_REPO}
echo GIT_URL=\${GIT_URL}
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a pipeline for the application`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc pipeline --tekton \\
\${GIT_URL}#master \\
--pipeline ibm-appmod-liberty \\
-p scan-image=false \\
-p health-endpoint=/ \\
-p java-bin-path=CustomerOrderServicesApp/target
`}</code></pre>
        <ul parentName="li">
          <li parentName="ul">{`Notice above that the Toolkit `}<inlineCode parentName="li">{`pipeline`}</inlineCode>{` CLI plugin accepts pipeline names and parameters`}</li>
          <li parentName="ul">{`The endpoint to check that the external access is possible is `}<inlineCode parentName="li">{`/`}</inlineCode></li>
          <li parentName="ul">{`The Java bin path is not located based on the root of the git repository and instead in `}<inlineCode parentName="li">{`CustomerOrderServicesApp/target`}</inlineCode></li>
          <li parentName="ul">{`Every application would have custom values you can pass them to the pipeline as parameters.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verity that the Pipeline started using the URL printed by the command`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`This is a good moment to take a break as the pipelines will take a few minutes.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify that Pipeline Run completed successfully`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the Pipeline Tasks/Stages`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Test`}</li>
          <li parentName="ul">{`Open SonarQube from Console Link`}</li>
          <li parentName="ul">{`Open Registry from Console Link`}</li>
          <li parentName="ul">{`Open Artifactory from Console Link`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the Application in GitOps git reposistory. The pipeline step `}<inlineCode parentName="p">{`gitops`}</inlineCode>{` is pushing the application manifest into the GitOps git repository`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Open `}<strong parentName="li">{`Git Ops`}</strong>{` from Console link`}</li>
          <li parentName="ul">{`Navigate to `}<inlineCode parentName="li">{`project01/qa/project01/appmod-liberty-toolkit`}</inlineCode></li>
          <li parentName="ul">{`Review the Helm Chart for the Application`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Register the Application in ArgoCD to deploy using GitOps`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Select ArgoCD from the Console Link and login using OpenShift login`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`NEW APP`}</strong></li>
          <li parentName="ul">{`Application Name: \${TOOLKIT_PROJECT}-qa-websphere-liberty (ie project01-qa-websphere-liberty)`}</li>
          <li parentName="ul">{`ArgoCD Project: `}<inlineCode parentName="li">{`default`}</inlineCode></li>
          <li parentName="ul">{`Sync Policy: `}<inlineCode parentName="li">{`Automatic`}</inlineCode>{` (Check prune resources and self heal)`}</li>
          <li parentName="ul">{`Repository URL: `}<inlineCode parentName="li">{`http://gogs.tools:3000/toolkit/gitops.git`}</inlineCode></li>
          <li parentName="ul">{`Revision: `}<inlineCode parentName="li">{`HEAD`}</inlineCode></li>
          <li parentName="ul">{`Path: `}<inlineCode parentName="li">{`qa/\${TOOLKIT_PROJECT}/appmod-liberty-toolkit`}</inlineCode>{` (ie project01/qa/project01/appmod-liberty-toolkit)`}</li>
          <li parentName="ul">{`Cluster: `}<inlineCode parentName="li">{`in-cluster`}</inlineCode></li>
          <li parentName="ul">{`Namespace: `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-qa`}</inlineCode>{` (ie. project01-qa)`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`CREATE`}</strong></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the Applications in ArgoCD`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Filter by Namespace `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-qa`}</inlineCode>{` (ie project01-qa)`}</li>
          <li parentName="ul">{`Review Application: `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-websphere-liberty`}</inlineCode>{` (ie project01-websphere-liberty)`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the Application in OpenShift`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Switch to Developer perspective`}</li>
          <li parentName="ul">{`Select `}<strong parentName="li">{`Topology`}</strong>{` from the menu`}</li>
          <li parentName="ul">{`Switch to project `}<inlineCode parentName="li">{`\${TOOLKIT_PROJECT}-qa`}</inlineCode>{` (ie project01-qa)`}</li>
          <li parentName="ul">{`Click on the route url from the `}<inlineCode parentName="li">{`appmod-liberty-toolkit`}</inlineCode>{` deployment, or the link on the circle.`}</li>
          <li parentName="ul">{`Add `}<inlineCode parentName="li">{`/CustomerOrderServicesWeb`}</inlineCode>{` to the end of the URL in the browser to access the application`}</li>
          <li parentName="ul">{`Log in to the application with username: `}<inlineCode parentName="li">{`rbarcia`}</inlineCode>{` and password: `}<inlineCode parentName="li">{`bl0wfish`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Now the Websphere application is ready, the development teams can make changes to git repository for the application, while the gitops git repository is owned by the operations team.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Congratulations you finished this activity, continue with another lab in the workshop`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      